module.exports = __webpack_public_path__ + "img/mobile-xs-icon.1dd41e8f.svg";